<template>
  <div class="container">
    <h1 class="mb-4">Corte {{ monthly_cut.cut_day }} de {{ monthly_cut.month }} del {{ monthly_cut.year }}</h1>

    <div class="row pb-5">
      <sys-widget title="Cantidad de Acreedores" :content="monthly_cut.investor_count" icon="users" size="3"/>
      <sys-widget title="Monto Inversión Inicial" :content="monthly_cut.amount | formatCurrency" icon="dollar-sign" color="secondary" size="3"/>
      <sys-widget :title="monthly_cut.status !== 'Aprobado' ? 'Monto Inversión Final (Estimado)' : 'Monto Inversión Final'" :content="monthly_cut.end_amount | formatCurrency" icon="dollar-sign" color="secondary" :content_color="monthly_cut.status !== 'Aprobado' ? 'warning' : 'white'" size="3"/>
      <sys-widget title="Interés Neto" :content="monthly_cut.gross_interest - monthly_cut.gross_retention | formatCurrency" :icon="['far', 'money-bill-alt']" size="3" />
    </div>

    <div class="details">
      <div class="details__head row pl-3">
        <ul class="nav nav-tabs col-sm-9" role="tablist">
          <li class="nav-item tabs-item">
            <a class="nav-link active" data-toggle="tab" role="tab" href="#investors"><fai icon="users"/>
              &nbsp;Acreedores
            </a>
          </li>
          <li class="nav-item tabs-item">
            <a class="nav-link" data-toggle="tab" role="tab" href="#attachments"><fai icon="credit-card"/>
              &nbsp;Anexos
            </a>
          </li>
          <li class="nav-item tabs-item" v-if="monthly_cut.status == 'Aprobado'">
            <a class="nav-link" data-toggle="tab" role="tab" href="#payments">
              <fai :icon="['far','money-bill-alt']"/>
              &nbsp;Pagos
            </a>
          </li>
          <li class="nav-item tabs-item">
            <a class="nav-link" data-toggle="tab" role="tab" href="#send-mail"><fai icon="envelope"/>
              &nbsp;Envío de estado de cuenta
            </a>
          </li>
          <li class="nav-item tabs-item">
            <a class="nav-link" data-toggle="tab" role="tab" href="#log"><fai icon="list"/>
              &nbsp;Reporte de correos
            </a>
          </li>
        </ul>
        <div class="col-sm-3 text-right" v-if="monthly_cut.status">
         <button class="btn btn-primary" @click="exportCSV">
            <fai :icon="['fas','download']"/> Reporte mensual
          </button>
          <button class="btn btn-success" @click="recalculateCut" v-if="monthly_cut.status != 'Aprobado'">
            <fai :icon="['fas','calculator']"/> Recalcular
          </button>
          <button class="btn btn-green text-white" @click="completeCut" v-if="monthly_cut.status != 'Aprobado'">
            <fai :icon="['fas','clipboard-check']"/> Completar Corte
          </button>
          <span class="pull-right" v-if="monthly_cut.status == 'Aprobado'">
            <h2 class="font-primary">{{ monthly_cut.status }}</h2>
          </span>
        </div>
      </div>
      <div class="details__body mt-4">
        <div class="tab-content">
          <!--begin: Investors -->
          <div id="investors" class="tab-pane fade show active" role="tabpanel">
            <sys-table :headers="investor_headers" :items="investors" title="Acreedores"/>
          </div>
          <!--end: Investors -->
          <!--begin: Attachments -->
          <div id="attachments" class="tab-pane fade" role="tabpanel">
            <sys-table :headers="attachment_headers" :items="attachments" title="Anexos" title_icon="credit-card"/>
          </div>
          <!--end: Attachments -->
          <!--begin: Payments -->
          <div id="payments" class="tab-pane fade" role="tabpanel" v-if="monthly_cut.status == 'Aprobado'">
            <button class="btn btn-success" @click="getDispersion">
              <fai :icon="['fas','download']"/> TXT Banorte
            </button>
            <button class="btn btn-green text-white" @click="getDispersionInter">
              <fai :icon="['fas','download']"/> TXT Interbancario
            </button>
            <sys-table :headers="payment_headers" :items="payments" title="Pagos" title_icon="credit-card"/>
          </div>
          <!--end: Payments -->
          <!--begin: Email -->
          <div id="send-mail" class="tab-pane fade" role="tabpanel">
            <div class="row">
              <div class="col">
                <h2>Envío de correos</h2>
              </div>
            </div>
            <sys-form ref="formStatements" :inputs="mail_info"/>
            <div class="row mt-4">
              <div class="col">
                <h5>Acreedores</h5>
              </div>
            </div>
            <sys-table ref="tableStatements" :headers="statements_headers" :items="investors" :selectable="true"/>
            <div class="row">
              <div class="col-sm-12 text-right" v-if="monthly_cut.status == 'Aprobado'">
                <button v-if="generationInProcess == false" class="btn btn-warning" @click="generateStatements">
                  <fai :icon="['far','file']"/>Generar Estados de Cuenta
                </button>
                <button v-else class="btn btn-warning" style="opacity: 0.5; cursor: initial;">
                  <fai :icon="['far','file']"/> Generar Estados de Cuenta
                </button>
                &nbsp;
                <button v-if="sendInProcess == false" class="btn btn-green text-white" @click="sendStatements">
                  <fai :icon="['fas','envelope']"/> Enviar Estados de Cuenta
                </button>
                <button v-else class="btn btn-green text-white" style="opacity: 0.5; cursor: initial;">
                  <fai :icon="['fas','envelope']"/> Enviar Estados de Cuenta
                </button>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <p class="text-danger" v-if="error">
                  {{ error }}
                </p>
              </div>
            </div>
          </div>
          <!--end: Email -->
          <!--begin: Email Log -->
          <div id="log" class="tab-pane fade" role="tabpanel">
            <sys-table :headers="log_headers" :items="logs" title="Bitacora de envío" error_message="No se encontraron envíos" title_icon="list"/>
          </div>
          <!--end: Email Log -->
        </div>
      </div>
      <complete-monthly-cut :monthly_cut="monthly_cut"
                    @monthlyCutCompleted="onMonthlyCutCompleted">
      </complete-monthly-cut>
    </div>
  </div>
</template>

<script>
import * as $ from 'jquery'
import monthlyCutService from '@/services/monthly_cuts'
import SysTable from '@/components/shared/Table'
import SysWidget from '@/components/shared/Widget'
import SysForm from '@/components/shared/Form'
import formMixin from '@/mixins/form'
import CompleteMonthlyCut from './CompleteMonthlyCut'
import saveAs from 'file-saver'

export default {
  name: 'MonthlyCutDetail',

  components: { SysTable, SysForm, SysWidget, CompleteMonthlyCut },

  mixin: [ formMixin ],

  data () {
    return {
      monthly_cut: {},
      isDisabled: false,
      error: null,
      file_url: null,
      generationInProcess: false,
      sendInProcess: false,
      investor_headers: [
        { text: 'Id', value: 'id' },
        { text: 'Nombre', value: 'name' },
        { text: 'Anexos', value: 'attachment_count', class: 'text-center' },
        { text: 'Monto de inversión', value: 'amount', filter: 'formatCurrency', class: 'text-right' },
        { text: 'Interés Bruto', value: 'gross_interest', filter: 'formatCurrency', class: 'text-right' },
        { text: 'Retención', value: 'retention', filter: 'formatCurrency', class: 'text-right' },
        { text: 'Interés Neto', value: 'net_interest', filter: 'formatCurrency', class: 'text-right' },
        { text: 'Monto Final', value: 'end_amount', filter: 'formatCurrency', class: 'font-weight-bold text-right' }
      ],
      attachment_headers: [
        { text: 'Contrato', value: 'contract', class: 'text-center' },
        { text: 'Acreedor', value: 'investor' },
        { text: 'Fecha Inicio', value: 'init_date', filter: 'reverseDate', class: 'text-center' },
        { text: 'Fecha Fin', value: 'end_date', filter: 'reverseDate', class: 'text-center' },
        { text: 'Plazo', value: 'days_calculated', class: 'text-center' },
        { text: 'Monto', value: 'amount', filter: 'formatCurrency', class: 'text-right' },
        { text: 'Interés Bruto', value: 'gross_interest', filter: 'formatCurrency', class: 'text-right' },
        { text: 'Retención', value: 'retention', filter: 'formatCurrency', class: 'text-right' },
        { text: 'ISR', value: 'isr', class: 'text-center' },
        { text: 'Interés Neto', value: 'net_interest', filter: 'formatCurrency', class: 'text-right' },
        { text: 'Monto Final', value: 'end_amount', filter: 'formatCurrency', class: 'font-weight-bold text-right' }
      ],
      statements_headers: [
        { text: 'Id', value: 'id' },
        { text: 'Nombre', value: 'name' },
        { text: 'Email', value: 'email_status' },
        { text: 'Anexos', value: 'attachment_count', class: 'text-center' },
        { text: 'Monto de inversión', value: 'amount', filter: 'formatCurrency', class: 'text-right' },
        { text: 'Interés Bruto', value: 'gross_interest', filter: 'formatCurrency', class: 'text-right' },
        { text: 'Retención', value: 'retention', filter: 'formatCurrency', class: 'text-right' },
        { text: 'Estado de Cuenta', value: 'statement', link: false, statement: true, class: 'text-center' },
        { text: 'Efectivo', value: 'statement2', link: false, statement: true, class: 'text-center' }
      ],
      payment_headers: [
        { text: 'Acreedor', value: 'investor' },
        { text: 'Coacreedor', value: 'beneficiary' },
        { text: 'Contrato', value: 'contract', class: 'text-center' },
        { text: 'Concepto', value: 'concept' },
        { text: 'Monto', value: 'amount', filter: 'formatCurrency', class: 'text-right' },
        { text: 'Método de Pago', value: 'payment_method' },
        { text: 'Cuenta bancaria', value: 'bank_account' }

      ],
      investors: [],
      investorsIds: [],
      attachments: [],
      payments: [],
      log_headers: [
        { text: 'Acreedor', value: 'name' },
        { text: 'Correo', value: 'email' },
        { text: 'Asunto', value: 'subject' },
        { text: 'Enviado', value: 'created_at' },
        { text: 'Respuesta', value: 'event', class: 'text-center font-weight-bold' },
        { text: 'Mensaje', value: 'message' },
        { text: 'Leído', value: 'timestamp' }
      ],
      logs: [],
      mail_info: {
        subject: {
          name: 'Asunto',
          hint: 'Asunto',
          value: '',
          type: 'text',
          validate: 'required',
          size: 6
        },
        bcc: {
          name: 'BCC',
          hint: 'Correos ocultos (separados por coma)',
          value: '',
          type: 'text',
          size: 6
        },
        email: {
          name: 'Email',
          hint: 'Remitente',
          value: '',
          type: 'email',
          size: 6
        },
        sender: {
          name: 'Nombre',
          hint: 'Nombre del Remitente',
          value: '',
          type: 'text',
          size: 6
        },
        message: {
          name: 'Mensaje',
          hint: 'Escribe el cuerpo del correo',
          value: '',
          type: 'textarea',
          validate: 'required',
          size: 12
        }
      },
      investor_mail_headers: [
        { text: 'Id', value: 'id' },
        { text: 'Nombre', value: 'fullname' },
        { text: 'Email', value: 'email' },
        { text: 'Envios', value: 'send_mails' }
      ]
    }
  },
  beforeCreate: function () {
    const id = this.$route.params.id

    monthlyCutService.getById(id).then(res => {
      this.monthly_cut = res.data
    })

    monthlyCutService.getInvestors(id).then(res => {
      this.investors = res.data
    })

    monthlyCutService.getLogs(id).then(res => {
      this.logs = res.data
    })
  },
  created: function () {
    const id = this.$route.params.id
    monthlyCutService.getPayments(id).then(res => {
      this.payments = res.data
    })
    monthlyCutService.getAttachments(id).then(res => {
      this.attachments = res.data
    })
  },
  methods: {
    recalculateCut () {
      monthlyCutService.updateById(this.$route.params.id).then(res => {
        this.$router.go(this.$router.currentRoute)
      }).catch(err => {
        console.log(JSON.stringify(err.data))
      })
    },
    exportCSV () {
      const id = this.$route.params.id
      monthlyCutService.getMonthlyCutReport(id).then(res => {
        if (res.error) {
          this.error = res.error
        } else {
          this.error = null
          window.open(res.url, '_blank')
        }
      }).catch(err => {
        console.log(JSON.stringify(err.data))
      })
    },
    generateStatements: function () {
      let body = {}
      body['investors'] = this.$refs.tableStatements.selected.join(',')

      this.generationInProcess = true
      monthlyCutService.generateStatements(this.$route.params.id, body).then(res => {
        if (res.error) {
          this.error = res.error
          this.generationInProcess = false
        } else {
          this.error = null
          this.$router.go(this.$router.currentRoute)
        }
      }).catch(err => {
        console.log(JSON.stringify(err.data))
      })
    },
    sendStatements: function () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          let body = {}

          body['subject'] = this.$refs.formStatements.inputs.subject.value
          body['bcc'] = this.$refs.formStatements.inputs.bcc.value
          body['email'] = this.$refs.formStatements.inputs.email.value
          body['sender_name'] = this.$refs.formStatements.inputs.sender.value
          body['message'] = this.$refs.formStatements.inputs.message.value
          body['investors'] = this.$refs.tableStatements.selected.join(',')

          this.sendInProcess = true
          monthlyCutService.sendStatements(this.$route.params.id, body).then(res => {
            if (res.error) {
              this.error = res.error
              this.sendInProcess = false
            } else {
              this.error = null
              alert(res.message)
              const id = this.$route.params.id
              monthlyCutService.getLogs(id).then(res => {
                this.logs = res.data
              })
              this.sendInProcess = false
            }
          }).catch(err => {
            console.log(JSON.stringify(err.data))
          })
        }
      })
    },
    getDispersion: function () {
      const id = this.$route.params.id
      console.log(id)
      monthlyCutService.getDispersion(id).then(res => {
        if (res.error) {
          console.log(res.error)
        } else {
          if (res.errors && confirm('¿Deseas descargar la información pendiente?')) {
            let pending = res.errors
            let errorfile = 'pendientes_pagos_' + id + '_banorte.txt'
            let file = new Blob([pending], {
              type: 'text/plain;charset=utf-8'
            })
            saveAs(file, errorfile)
          }
          let content = res.txt
          let filename = 'dispersion_' + id + '_banorte.txt'
          let blob = new Blob([content], {
            type: 'text/plain;charset=utf-8'
          })
          saveAs(blob, filename)
        }
      }).catch(err => {
        console.log(JSON.stringify(err.data))
      })
    },
    getDispersionInter: function () {
      const id = this.$route.params.id
      console.log(id)
      monthlyCutService.getDispersionInter(id).then(res => {
        if (res.error) {
          console.log(res.error)
        } else {
          if (res.errors && confirm('¿Deseas descargar la información pendiente?')) {
            let pending = res.errors
            let errorfile = 'pendientes_pagos_' + id + '_interbancaria.txt'
            let file = new Blob([pending], {
              type: 'text/plain;charset=utf-8'
            })
            saveAs(file, errorfile)
          }
          let content = res.txt
          let filename = 'dispersion_' + id + '_interbancaria.txt'
          let blob = new Blob([content], {
            type: 'text/plain;charset=utf-8'
          })
          saveAs(blob, filename)
        }
      }).catch(err => {
        console.log(JSON.stringify(err.data))
      })
    },
    completeCut: function () {
      $('#complete-cut').modal()
    },
    onMonthlyCutCompleted: function () {
      window.location.reload()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/monthly_cuts/MonthlyCutDetail.vue